import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.SUPPLIER_SET_SUPPLIERS]: (state, payload) => {
    const base = payload.supplierList

    const supplierListTmp = base.map((ele) => {
      return {
        abbreviation: ele.abbreviation,
        address1: ele.address1,
        address2: ele.address2,
        addressCountryId: ele.addressCountryId,
        createdAt: ele.createdAt,
        description: ele.description,
        email: ele.email,
        faxNumber: ele.faxNumber,
        faxNumberCountryId: ele.faxNumberCountryId,
        locationId: ele.locationId,
        name: ele.name,
        organizationId: ele.organizationId,
        paymentCriteria: ele.paymentCriteria,
        phoneNumber: ele.phoneNumber,
        phoneNumberCountryId: ele.phoneNumberCountryId,
        postalCode: ele.postalCode,
        regionId: ele.regionId,
        rep: ele.rep,
        section: ele.section,
        sortNumber: ele.sortNumber,
        suggestedReceivingLocationId: ele.suggestedReceivingLocationId,
        supplierId: ele.supplierId,
        updatedAt: ele.updatedAt,
        suggestedReceivingLocation: ele.suggestedReceivingLocation,
        contactInfo: ele.contactInfo,
        addressInfo: ele.addressInfo,
        isEnabled: ele.isEnabled
      }
    })

    state.suppliers = supplierListTmp

    const sortNumberList = supplierListTmp.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.supplierMaxSortNumber = Math.max(...sortNumberList)
    }
  },
  [mutationsTypes.SUPPLIER_SET_SUPPLIER_ID_NAME_LIST]: (state, payload) => {
    state.supplierIdNameList = payload
  },
  [mutationsTypes.SUPPLIER_SET_SUGGESTED_RECIEVING_LOCATION_LIST]: (
    state,
    payload
  ) => {
    state.suggestedReceivingLocationList =
      payload.suggestedReceivingLocationList

    const sortNumberList = payload.suggestedReceivingLocationList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.suggestedReceivingLocationMaxSortNumber = Math.max(
        ...sortNumberList
      )
    }
  },
  [mutationsTypes.SUPPLIER_SET_SUPPLIER_ID_NAME_AND_DESCRIPTION_LIST]: (
    state,
    payload
  ) => {
    state.supplierIdNameAndDescriptionList = payload
  }
}

export default Mutations
